import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { openSMLUpgradePrompt } from '../../../../redux/slices/appInfo/slice';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { SMLUpgradeFeature } from '../../../music24/config/music24PlanCapabilities';
import { footageMessages } from '../../messages/footageMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The AI tab on Free and in the trial (design h4): what an AI clip is, and "See the plans". */
const AiLockedCardComponent: React.FC<{ credits: number }> = ({ credits }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  return (
    <>
      <div className={styles.lock}>
        <b>{intl.formatMessage(footageMessages.lockTitle)}</b>
        <p>{intl.formatMessage(footageMessages.lockText, { credits })}</p>
        <SMLButton
          size="sm"
          omitCap
          onClick={() => dispatch(openSMLUpgradePrompt({ feature: SMLUpgradeFeature.generic }))}
        >
          {intl.formatMessage(footageMessages.lockButton)}
        </SMLButton>
      </div>
      <p className={styles.hint}>{intl.formatMessage(footageMessages.lockHint)}</p>
    </>
  );
};

export const AiLockedCard = TypedMemo(AiLockedCardComponent);
